import React, { useState } from 'react'
import { Formik, Form } from 'formik';
import { InputLayout, MainInput, SubmitButton } from '../../components';
import { useDispatch,useSelector } from 'react-redux';
import { setFormSubmitting } from '../../../application/store/actions/ui';
import { getFormSubmittingState } from '../../../application/store/selectors/ui';
import services from '../../../ioc/services';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../../application/utils/Routes';
import AdminsDropdown from '../AdminsDropdown';
import { getLoggedInUser } from '../../../application/store/selectors/user';


function AddAgentForm({ isEdit = false, agentData = null }) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector(getLoggedInUser)

    const isFormSubmitting = useSelector(getFormSubmittingState)

    const [assignedAdmin, setAssignedAdmin] = useState(agentData?.adminId);

    return (
        <div className="w-full p-6">
            <Formik
                initialValues={agentData ?? {}}
                onSubmit={async (values) => {

                    dispatch(setFormSubmitting(true))

                    if (!isEdit) {
                        services.api.agent.addAgent(values)
                            .then(res => {
                                services.alert.toast.success("Agent Created Successfully");
                                navigate(ROUTES.AGENTS)
                            }).catch(err => {
                                services.alert.toast.error(err)
                            })
                            .finally(() => {
                                dispatch(setFormSubmitting(false))
                            })
                    }
                    else {

                        if (agentData == null) {
                            services.alert.toast.error("No data to submit");
                            dispatch(setFormSubmitting(false))
                            return;
                        }
                        if (!assignedAdmin) {
                            services.alert.toast.error("Please select an admin");
                            dispatch(setFormSubmitting(false))
                            return;
                        }

                        const userData = {
                            ...values,
                            adminId: assignedAdmin
                        }


                        services.api.agent.editAgent(agentData.id, userData)
                            .then(res => {
                                services.alert.toast.success("Agent Updated Successfully");
                                window.location.reload();
                            }).catch(err => {
                                services.alert.toast.error(err)
                            })
                            .finally(() => {
                                dispatch(setFormSubmitting(false))
                            })

                    }

                    dispatch(setFormSubmitting(false))
                }}>
                <Form className="md:grid grid-cols-2 gap-10 w-full ">
                    <MainInput label="First Name" name="firstName" type="text" placeholder=" " />
                    <MainInput label="Last Name" name="lastName" type="text" placeholder=" " />
                    <MainInput label="Email" name="email" type="text" placeholder=" " />
                    <MainInput label="Phone Number" name="phoneNumber" type="text" placeholder=" " />
                    <MainInput label="Location" name="location" type="text" placeholder=" " />
                    {isEdit && user.role.toLowerCase() == 'superadmin' && <InputLayout name="admin" label="Select Admin">
                        <AdminsDropdown valueUpdater={(admin) => {
                            setAssignedAdmin(admin.value)
                        }} defaultValue={assignedAdmin} />
                    </InputLayout>}
                    <div className='col-span-2 flex justify-center'>
                        <SubmitButton text={isEdit ? "Update Agent" : "Add Agent"} classes="w-auto px-32" disabled={isFormSubmitting} />
                    </div>

                </Form>

            </Formik>



        </div>
    )
}

export default AddAgentForm
